import { useState, useEffect } from 'react'
import { AddButton } from '../Account/ReadingListItems/components/AddButton'

export function CommentFooter() {
  const [liked, setLiked] = useState(0)
  const [likesCount, setLikesCount] = useState(0)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    setLiked(+App.State.liked)
    setLikesCount(App.State.likesCount)
  }, [])

  const handleLikeChange = (likeStatus, count) => {
    setLiked(+likeStatus)
    setLikesCount(count)
  }

  const handleLikeRemove = () => {
    App.Request.delete(`/likes/${App.State.likeableId}`, {
      data: {
        likeable_id: App.State.likeableId,
        likeable_type: App.State.likeableType,
      },
    })
      .then(({ status, data }) => {
        setSubmitting(false)

        if (status !== 200) return

        handleLikeChange(0, data.likes_count)
      })
      .catch(() => null)
  }

  const handleLikeAdd = () => {
    App.Request.post('/likes.json', {
      likeable_id: App.State.likeableId,
      likeable_type: App.State.likeableType,
    }).then(({ status, data }) => {
      setSubmitting(false)

      if (status !== 201) return

      handleLikeChange(1, data.likes_count)
    })
  }

  const handleLikeAction = (likeStatus) => {
    setSubmitting(true)
    if (likeStatus === 1) {
      handleLikeRemove()
    } else {
      handleLikeAdd()
    }
  }

  return (
    <div id="comment-footer" className="container comment-footer-wrapper">
      <div
        className={`fixed-comment-footer${
          App.State.isMobile ? ' mobile-footer' : ''
        }`}
      >
        <div className="action-buttons">
          <button
            type="button"
            className="action-button"
            name="liked"
            disabled={submitting}
            value={liked}
            onClick={() => handleLikeAction(liked)}
          >
            <i
              className={`fas fa-heart me-1 ${
                liked ? ' like-red' : 'like-outline-red like-button'
              }`}
            />
            {likesCount}
          </button>
          <a href="#comments">
            <button className="action-button" type="button">
              <i className="far fa-comment me-1" />
              {App.State.commentsCount}
            </button>
          </a>
          {App.State.userSignedIn && <AddButton postId={App.State.postId} />}
          <button
            type="button"
            id="share-dropdown"
            className="action-button share-button"
            aria-haspopup="true"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            data-controller="share-button"
            data-share-title={App.State.title}
            data-share-message={App.State.title}
            data-share-url={App.State.url}
          >
            <i className="fa fa-share-alt text-primary me-1" />
            {I18n.t('share')}
          </button>
          <div className="dropdown-menu" aria-labelledby="share-dropdown">
            <div className="share-icon-list">
              <div className="share-icon-wrapper">
                <a
                  className="share-icon dropdown-item"
                  href={`mailto:?body=${
                    App.State.title + window.location.href
                  }&subject=${App.State.title}`}
                >
                  <i className="fas fa-envelope mail-icon me-1" />
                  Mail
                </a>
                <a
                  className="share-icon dropdown-item"
                  target="_blank"
                  rel="nofollow noreferrer"
                  href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}
                >
                  <i className="fab fa-facebook fb-icon me-1" />
                  Facebook
                </a>
                <a
                  className="share-icon dropdown-item"
                  target="_blank"
                  rel="nofollow noreferrer"
                  href={`https://twitter.com/intent/tweet?text=${
                    App.State.title + window.location.href
                  }`}
                >
                  <i className="fab fa-twitter twitter-icon me-1" />
                  Twitter
                </a>
                <a
                  className="share-icon dropdown-item"
                  target="_blank"
                  rel="nofollow noreferrer"
                  href={`https://pinterest.com/pin/create/link/?url=${window.location.href}`}
                >
                  <i className="fab fa-pinterest pinterest-icon me-1" />
                  Pinterest
                </a>
                <a
                  className="share-icon dropdown-item"
                  target="_blank"
                  rel="nofollow noreferrer"
                  href={`https://reddit.com/submit?url=${
                    window.location.href
                  }&title=${encodeURIComponent(App.State.title)}`}
                >
                  <i className="fab fa-reddit reddit-icon me-1" />
                  Reddit
                </a>
              </div>
            </div>
          </div>
        </div>
        {App.State.nextPostTitle && (
          <div className="next-post d-none d-md-block">
            <b className="link-default">NEXT:</b>&nbsp;
            <a className="next-link" href={`/posts/${App.State.nextPostId}`}>
              {App.State.nextPostTitle}
            </a>
          </div>
        )}
      </div>
    </div>
  )
}
